module.exports = __webpack_public_path__ + "img/i-phone-cropped.57722a7e.svg";